/**
 * Generated by orval v7.0.1 🍺
 * Do not edit manually.
 * API V5
 * OpenAPI spec version: v5
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ErrorObjectArray,
  ForbiddenErrorObject,
  GetApiV5FirmsServiceAliases200,
  GetApiV5FirmsServiceAliasesParams,
  GetApiV5FirmsServiceAliasesSuggestions200,
  GetApiV5FirmsServiceAliasesSuggestionsParams,
  PatchApiV5FirmsServiceAliasesIdBody,
  PostApiV5FirmsServiceAliasesBody,
  PostApiV5FirmsServiceAliasesBulkConfirm200,
  PostApiV5FirmsServiceAliasesBulkConfirmBody,
  ServiceAlias
} from '.././schemas'
import getApiV5FirmsServiceAliasesMutator from '../../configOrvalAPIV5';
import type { ErrorType as GetApiV5FirmsServiceAliasesErrorType } from '../../configOrvalAPIV5';
import postApiV5FirmsServiceAliasesMutator from '../../configOrvalAPIV5';
import type { ErrorType as PostApiV5FirmsServiceAliasesErrorType } from '../../configOrvalAPIV5';
import patchApiV5FirmsServiceAliasesIdMutator from '../../configOrvalAPIV5';
import type { ErrorType as PatchApiV5FirmsServiceAliasesIdErrorType } from '../../configOrvalAPIV5';
import deleteApiV5FirmsServiceAliasesIdMutator from '../../configOrvalAPIV5';
import type { ErrorType as DeleteApiV5FirmsServiceAliasesIdErrorType } from '../../configOrvalAPIV5';
import postApiV5FirmsServiceAliasesIdConfirmMutator from '../../configOrvalAPIV5';
import type { ErrorType as PostApiV5FirmsServiceAliasesIdConfirmErrorType } from '../../configOrvalAPIV5';
import postApiV5FirmsServiceAliasesIdResetMutator from '../../configOrvalAPIV5';
import type { ErrorType as PostApiV5FirmsServiceAliasesIdResetErrorType } from '../../configOrvalAPIV5';
import postApiV5FirmsServiceAliasesBulkConfirmMutator from '../../configOrvalAPIV5';
import type { ErrorType as PostApiV5FirmsServiceAliasesBulkConfirmErrorType } from '../../configOrvalAPIV5';
import getApiV5FirmsServiceAliasesSuggestionsMutator from '../../configOrvalAPIV5';
import type { ErrorType as GetApiV5FirmsServiceAliasesSuggestionsErrorType } from '../../configOrvalAPIV5';



/**
 * @summary Returns service aliases for the CPA
 */
export const getApiV5FirmsServiceAliases = (
    params?: GetApiV5FirmsServiceAliasesParams,
 signal?: AbortSignal
) => {
      
      
      return getApiV5FirmsServiceAliasesMutator<GetApiV5FirmsServiceAliases200>(
      {url: `/api/v5/firms/service_aliases`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiV5FirmsServiceAliasesQueryKey = (params?: GetApiV5FirmsServiceAliasesParams,) => {
    return [`/api/v5/firms/service_aliases`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiV5FirmsServiceAliasesQueryOptions = <TData = Awaited<ReturnType<typeof getApiV5FirmsServiceAliases>>, TError = GetApiV5FirmsServiceAliasesErrorType<unknown>>(params?: GetApiV5FirmsServiceAliasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsServiceAliases>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV5FirmsServiceAliasesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV5FirmsServiceAliases>>> = ({ signal }) => getApiV5FirmsServiceAliases(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsServiceAliases>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV5FirmsServiceAliasesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV5FirmsServiceAliases>>>
export type GetApiV5FirmsServiceAliasesQueryError = GetApiV5FirmsServiceAliasesErrorType<unknown>


/**
 * @summary Returns service aliases for the CPA
 */

export function useGetApiV5FirmsServiceAliases<TData = Awaited<ReturnType<typeof getApiV5FirmsServiceAliases>>, TError = GetApiV5FirmsServiceAliasesErrorType<unknown>>(
 params?: GetApiV5FirmsServiceAliasesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsServiceAliases>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV5FirmsServiceAliasesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Creates a service alias for the CPA of the currently logged in user
 */
export const postApiV5FirmsServiceAliases = (
    postApiV5FirmsServiceAliasesBody: PostApiV5FirmsServiceAliasesBody,
 ) => {
      
      
      return postApiV5FirmsServiceAliasesMutator<ServiceAlias>(
      {url: `/api/v5/firms/service_aliases`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiV5FirmsServiceAliasesBody
    },
      );
    }
  


export const getPostApiV5FirmsServiceAliasesMutationOptions = <TError = PostApiV5FirmsServiceAliasesErrorType<ErrorObjectArray>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsServiceAliases>>, TError,{data: PostApiV5FirmsServiceAliasesBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsServiceAliases>>, TError,{data: PostApiV5FirmsServiceAliasesBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV5FirmsServiceAliases>>, {data: PostApiV5FirmsServiceAliasesBody}> = (props) => {
          const {data} = props ?? {};

          return  postApiV5FirmsServiceAliases(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV5FirmsServiceAliasesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV5FirmsServiceAliases>>>
    export type PostApiV5FirmsServiceAliasesMutationBody = PostApiV5FirmsServiceAliasesBody
    export type PostApiV5FirmsServiceAliasesMutationError = PostApiV5FirmsServiceAliasesErrorType<ErrorObjectArray>

    /**
 * @summary Creates a service alias for the CPA of the currently logged in user
 */
export const usePostApiV5FirmsServiceAliases = <TError = PostApiV5FirmsServiceAliasesErrorType<ErrorObjectArray>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsServiceAliases>>, TError,{data: PostApiV5FirmsServiceAliasesBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiV5FirmsServiceAliases>>,
        TError,
        {data: PostApiV5FirmsServiceAliasesBody},
        TContext
      > => {

      const mutationOptions = getPostApiV5FirmsServiceAliasesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Updates a service alias
 */
export const patchApiV5FirmsServiceAliasesId = (
    id: number,
    patchApiV5FirmsServiceAliasesIdBody: PatchApiV5FirmsServiceAliasesIdBody,
 ) => {
      
      
      return patchApiV5FirmsServiceAliasesIdMutator<ServiceAlias>(
      {url: `/api/v5/firms/service_aliases/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchApiV5FirmsServiceAliasesIdBody
    },
      );
    }
  


export const getPatchApiV5FirmsServiceAliasesIdMutationOptions = <TError = PatchApiV5FirmsServiceAliasesIdErrorType<void | ErrorObjectArray>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV5FirmsServiceAliasesId>>, TError,{id: number;data: PatchApiV5FirmsServiceAliasesIdBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiV5FirmsServiceAliasesId>>, TError,{id: number;data: PatchApiV5FirmsServiceAliasesIdBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiV5FirmsServiceAliasesId>>, {id: number;data: PatchApiV5FirmsServiceAliasesIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  patchApiV5FirmsServiceAliasesId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchApiV5FirmsServiceAliasesIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiV5FirmsServiceAliasesId>>>
    export type PatchApiV5FirmsServiceAliasesIdMutationBody = PatchApiV5FirmsServiceAliasesIdBody
    export type PatchApiV5FirmsServiceAliasesIdMutationError = PatchApiV5FirmsServiceAliasesIdErrorType<void | ErrorObjectArray>

    /**
 * @summary Updates a service alias
 */
export const usePatchApiV5FirmsServiceAliasesId = <TError = PatchApiV5FirmsServiceAliasesIdErrorType<void | ErrorObjectArray>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiV5FirmsServiceAliasesId>>, TError,{id: number;data: PatchApiV5FirmsServiceAliasesIdBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof patchApiV5FirmsServiceAliasesId>>,
        TError,
        {id: number;data: PatchApiV5FirmsServiceAliasesIdBody},
        TContext
      > => {

      const mutationOptions = getPatchApiV5FirmsServiceAliasesIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Destroys a service alias
 */
export const deleteApiV5FirmsServiceAliasesId = (
    id: number,
 ) => {
      
      
      return deleteApiV5FirmsServiceAliasesIdMutator<void>(
      {url: `/api/v5/firms/service_aliases/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteApiV5FirmsServiceAliasesIdMutationOptions = <TError = DeleteApiV5FirmsServiceAliasesIdErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV5FirmsServiceAliasesId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV5FirmsServiceAliasesId>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV5FirmsServiceAliasesId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiV5FirmsServiceAliasesId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiV5FirmsServiceAliasesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiV5FirmsServiceAliasesId>>>
    
    export type DeleteApiV5FirmsServiceAliasesIdMutationError = DeleteApiV5FirmsServiceAliasesIdErrorType<void>

    /**
 * @summary Destroys a service alias
 */
export const useDeleteApiV5FirmsServiceAliasesId = <TError = DeleteApiV5FirmsServiceAliasesIdErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiV5FirmsServiceAliasesId>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiV5FirmsServiceAliasesId>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteApiV5FirmsServiceAliasesIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Confirms a service alias (sets confirmed_at + confirmed_by_cpa_user_id)
 */
export const postApiV5FirmsServiceAliasesIdConfirm = (
    id: number,
 ) => {
      
      
      return postApiV5FirmsServiceAliasesIdConfirmMutator<ServiceAlias>(
      {url: `/api/v5/firms/service_aliases/${id}/confirm`, method: 'POST'
    },
      );
    }
  


export const getPostApiV5FirmsServiceAliasesIdConfirmMutationOptions = <TError = PostApiV5FirmsServiceAliasesIdConfirmErrorType<void | ErrorObjectArray>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesIdConfirm>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesIdConfirm>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesIdConfirm>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postApiV5FirmsServiceAliasesIdConfirm(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV5FirmsServiceAliasesIdConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesIdConfirm>>>
    
    export type PostApiV5FirmsServiceAliasesIdConfirmMutationError = PostApiV5FirmsServiceAliasesIdConfirmErrorType<void | ErrorObjectArray>

    /**
 * @summary Confirms a service alias (sets confirmed_at + confirmed_by_cpa_user_id)
 */
export const usePostApiV5FirmsServiceAliasesIdConfirm = <TError = PostApiV5FirmsServiceAliasesIdConfirmErrorType<void | ErrorObjectArray>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesIdConfirm>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesIdConfirm>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getPostApiV5FirmsServiceAliasesIdConfirmMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Resets a SmartVault Account mapping so it can be re-established (admin only, LISD-2586)
 */
export const postApiV5FirmsServiceAliasesIdReset = (
    id: number,
 ) => {
      
      
      return postApiV5FirmsServiceAliasesIdResetMutator<ServiceAlias>(
      {url: `/api/v5/firms/service_aliases/${id}/reset`, method: 'POST'
    },
      );
    }
  


export const getPostApiV5FirmsServiceAliasesIdResetMutationOptions = <TError = PostApiV5FirmsServiceAliasesIdResetErrorType<ForbiddenErrorObject | void | ErrorObjectArray>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesIdReset>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesIdReset>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesIdReset>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postApiV5FirmsServiceAliasesIdReset(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV5FirmsServiceAliasesIdResetMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesIdReset>>>
    
    export type PostApiV5FirmsServiceAliasesIdResetMutationError = PostApiV5FirmsServiceAliasesIdResetErrorType<ForbiddenErrorObject | void | ErrorObjectArray>

    /**
 * @summary Resets a SmartVault Account mapping so it can be re-established (admin only, LISD-2586)
 */
export const usePostApiV5FirmsServiceAliasesIdReset = <TError = PostApiV5FirmsServiceAliasesIdResetErrorType<ForbiddenErrorObject | void | ErrorObjectArray>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesIdReset>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesIdReset>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getPostApiV5FirmsServiceAliasesIdResetMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Confirms multiple service aliases in one request (Review modal)
 */
export const postApiV5FirmsServiceAliasesBulkConfirm = (
    postApiV5FirmsServiceAliasesBulkConfirmBody: PostApiV5FirmsServiceAliasesBulkConfirmBody,
 ) => {
      
      
      return postApiV5FirmsServiceAliasesBulkConfirmMutator<PostApiV5FirmsServiceAliasesBulkConfirm200>(
      {url: `/api/v5/firms/service_aliases/bulk_confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiV5FirmsServiceAliasesBulkConfirmBody
    },
      );
    }
  


export const getPostApiV5FirmsServiceAliasesBulkConfirmMutationOptions = <TError = PostApiV5FirmsServiceAliasesBulkConfirmErrorType<ErrorObjectArray | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesBulkConfirm>>, TError,{data: PostApiV5FirmsServiceAliasesBulkConfirmBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesBulkConfirm>>, TError,{data: PostApiV5FirmsServiceAliasesBulkConfirmBody}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesBulkConfirm>>, {data: PostApiV5FirmsServiceAliasesBulkConfirmBody}> = (props) => {
          const {data} = props ?? {};

          return  postApiV5FirmsServiceAliasesBulkConfirm(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiV5FirmsServiceAliasesBulkConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesBulkConfirm>>>
    export type PostApiV5FirmsServiceAliasesBulkConfirmMutationBody = PostApiV5FirmsServiceAliasesBulkConfirmBody
    export type PostApiV5FirmsServiceAliasesBulkConfirmMutationError = PostApiV5FirmsServiceAliasesBulkConfirmErrorType<ErrorObjectArray | void>

    /**
 * @summary Confirms multiple service aliases in one request (Review modal)
 */
export const usePostApiV5FirmsServiceAliasesBulkConfirm = <TError = PostApiV5FirmsServiceAliasesBulkConfirmErrorType<ErrorObjectArray | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesBulkConfirm>>, TError,{data: PostApiV5FirmsServiceAliasesBulkConfirmBody}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiV5FirmsServiceAliasesBulkConfirm>>,
        TError,
        {data: PostApiV5FirmsServiceAliasesBulkConfirmBody},
        TContext
      > => {

      const mutationOptions = getPostApiV5FirmsServiceAliasesBulkConfirmMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Lists unconfirmed service aliases (Mapping page needs-review list)
 */
export const getApiV5FirmsServiceAliasesSuggestions = (
    params?: GetApiV5FirmsServiceAliasesSuggestionsParams,
 signal?: AbortSignal
) => {
      
      
      return getApiV5FirmsServiceAliasesSuggestionsMutator<GetApiV5FirmsServiceAliasesSuggestions200>(
      {url: `/api/v5/firms/service_aliases/suggestions`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiV5FirmsServiceAliasesSuggestionsQueryKey = (params?: GetApiV5FirmsServiceAliasesSuggestionsParams,) => {
    return [`/api/v5/firms/service_aliases/suggestions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiV5FirmsServiceAliasesSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof getApiV5FirmsServiceAliasesSuggestions>>, TError = GetApiV5FirmsServiceAliasesSuggestionsErrorType<void>>(params?: GetApiV5FirmsServiceAliasesSuggestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsServiceAliasesSuggestions>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV5FirmsServiceAliasesSuggestionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV5FirmsServiceAliasesSuggestions>>> = ({ signal }) => getApiV5FirmsServiceAliasesSuggestions(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsServiceAliasesSuggestions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiV5FirmsServiceAliasesSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV5FirmsServiceAliasesSuggestions>>>
export type GetApiV5FirmsServiceAliasesSuggestionsQueryError = GetApiV5FirmsServiceAliasesSuggestionsErrorType<void>


/**
 * @summary Lists unconfirmed service aliases (Mapping page needs-review list)
 */

export function useGetApiV5FirmsServiceAliasesSuggestions<TData = Awaited<ReturnType<typeof getApiV5FirmsServiceAliasesSuggestions>>, TError = GetApiV5FirmsServiceAliasesSuggestionsErrorType<void>>(
 params?: GetApiV5FirmsServiceAliasesSuggestionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiV5FirmsServiceAliasesSuggestions>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiV5FirmsServiceAliasesSuggestionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



